import type { Dayjs } from "dayjs";
import type { BirthdaySDate } from "@/services/api/entities/person/types";

export const checkAnniversaryDate = (currentDate: Dayjs, someDate: BirthdaySDate): boolean => {
  const { day, month } = someDate;

  if (day == null || month == null) {
    return false;
  }

  return currentDate.date() === day && currentDate.month() + 1 === month;
};
